
import React from 'react';
import { useQuickscan } from '@/contexts/QuickscanContext';
import { Logo } from './Logo';

export const ProgressIndicator = () => {
  const { currentStep, subStep, activeExpansionPlan, data } = useQuickscan();
  
  // If we're in a sub-step, show sub-step progress
  if (subStep && activeExpansionPlan) {
    const planLabels = {
      location: 'Nieuwe locatie',
      sustainability: 'Duurzaamheidsdoelen', 
      growth: 'Bedrijfsgroei',
      equipment: 'Nieuwe apparatuur'
    };
    
    const planLabel = planLabels[activeExpansionPlan] || activeExpansionPlan;
    const totalPlans = data.expansionPlans.length;
    const completedPlans = Object.keys(data.expansionDetails).length;
    
    return (
      <div className="mb-8">
        {/* Header with logo */}
        <div className="flex items-center justify-between mb-4">
          <Logo />
          <span className="text-sm text-gray-600">
            {completedPlans} van {totalPlans} plannen ingevuld
          </span>
        </div>
        
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm text-energy-green font-medium">
            {planLabel} - Details invullen
          </span>
        </div>
        <div className="relative">
          <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
            <div 
              className="h-full bg-gradient-to-r from-energy-blue to-energy-green transition-all duration-500 ease-out relative"
              style={{ width: `${(completedPlans / Math.max(totalPlans, 1)) * 100}%` }}
            >
              <div className="absolute inset-0 animate-energy-pulse bg-white/20"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  // Regular progress for main steps
  const progress = ((currentStep - 1) / 6) * 100; // Steps 1-6 out of 7 total

  return (
    <div className="mb-8">
      {/* Header with logo */}
      <div className="flex items-center justify-between mb-4">
        <Logo />
        <span className="text-sm text-gray-600">
          {Math.round(progress)}% voltooid
        </span>
      </div>
      
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm text-energy-green font-medium">
          Stap {currentStep} van 6
        </span>
      </div>
      <div className="relative">
        <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
          <div 
            className="h-full bg-gradient-to-r from-energy-green to-energy-blue transition-all duration-500 ease-out relative"
            style={{ width: `${progress}%` }}
          >
            <div className="absolute inset-0 animate-energy-pulse bg-white/20"></div>
          </div>
        </div>
        <div className="absolute right-0 top-0 h-3 w-6 bg-energy-orange rounded-r-full opacity-80"></div>
      </div>
    </div>
  );
};
